module.exports = __webpack_public_path__ + "img/audi-event5.b15317a2.jpg";